import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { PageHero } from "../components/site/PageHero";
import { RIGHTS, RIGHTS_DISCLAIMER } from "../data/content";

export default function Rights() {
  return (
    <>
      <PageHero eyebrow="Employee Rights" title="Employee Rights & Protection" subtitle="Plain-language guidance on the workplace rights that matter most to IT and digital services employees." image="/images/paddy.jpg" testId="rights-hero" />
      <section className="py-16 md:py-24">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <aside className="lg:col-span-4">
            <div className="sticky top-32 space-y-5">
              <div className="rounded-xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900" data-testid="rights-disclaimer">
                <ShieldAlert className="mb-3 h-6 w-6" />
                <p className="font-semibold">Disclaimer</p>
                <p className="mt-2 leading-relaxed">{RIGHTS_DISCLAIMER}</p>
              </div>
              <div className="rounded-xl bg-navy p-6 text-white">
                <p className="font-display text-lg font-bold">Facing an issue at work?</p>
                <p className="mt-2 text-sm text-slate-300">Register a grievance or request legal assistance confidentially.</p>
                <div className="mt-5 flex flex-col gap-2">
                  <Link to="/contact#grievance" className="btn-green" data-testid="rights-grievance-link">Register a Grievance</Link>
                  <Link to="/legal-support#request" className="inline-flex justify-center rounded-lg border border-white/30 px-6 py-3 text-sm font-semibold hover:bg-white/10" data-testid="rights-legal-link">Request Legal Assistance</Link>
                </div>
              </div>
            </div>
          </aside>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible defaultValue="r0" className="space-y-3">
              {RIGHTS.map(({ icon: Icon, title, text, tips }, i) => (
                <AccordionItem key={title} value={`r${i}`} className="rounded-xl border border-slate-200 bg-white px-6">
                  <AccordionTrigger className="py-5 hover:no-underline" data-testid={`rights-item-${i}`}>
                    <span className="flex items-center gap-4 text-left font-display text-base font-bold text-navy">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-royal-light text-royal"><Icon className="h-5 w-5" /></span>{title}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6">
                    <p className="text-sm leading-relaxed text-slate-600">{text}</p>
                    <ul className="mt-4 grid gap-2 sm:grid-cols-3">
                      {tips.map((t) => <li key={t} className="rounded-lg bg-leaf-light/60 px-3 py-2 text-xs font-medium text-leaf-dark">{t}</li>)}
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </>
  );
}
